export const BUSINESS_PHONE_DISPLAY = '+1 (573) 214-2000';
export const BUSINESS_PHONE_HREF = 'tel:+15732142000';
export const BUSINESS_EMAIL = 'facialplasticsurgery@moentcenter.com';
export const BUSINESS_EMAIL_HREF = `mailto:${BUSINESS_EMAIL}`;
